// import config from '@/config'
import Vue from 'vue'
import VueRouter from 'vue-router'
import List from '../views/secondMenu/List.vue'
import Info from '../views/secondMenu/Info.vue' 

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/home/index.vue'),
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('../views/secondMenu/index.vue'),
    children: [
      {
        path: "lists/:menuId",
        name: 'lists',
        component: List
      },
      {
        path: "search",
        name: 'search',
        component: List
      },
      {
        path: "info/:infoId",
        name: 'info',
        component: Info
      }
    ],
  },
  {
    path: '*',
    redirect: '/'
  }
]
// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
let routerReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}
// replace
VueRouter.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err)
}
const router = new VueRouter({
  mode: 'history',
  // base: config.publicPath,
  routes
})

export default router